export class ObjectUtils {
    /**
     * Tells if the object is null or undefined.
     * @param obj object to test.
     */
    public static isNullOrUndefined(obj: any) {
        return obj === null || obj === undefined;
    }
}
